import usePharmacyQuery from '@/hooks/pharmacy/usePharmacyQuery';
import { useState } from 'react';

enum OptionType {
  WRONG_PRICE = 'WRONG_PRICE',
  PRESCRIPTION_CHANGE = 'PRESCRIPTION_CHANGE',
  OUT_OF_STOCK = 'OUT_OF_STOCK'
}

const options = [
  {
    label: '가격 오기입으로 인한 결제 금액 변경',
    value: OptionType.WRONG_PRICE
  },
  {
    label: '처방전 수정으로 인한 결제 금액 변경',
    value: OptionType.PRESCRIPTION_CHANGE
  },
  { label: '약품 재고 부족으로 인한 조제 불가', value: OptionType.OUT_OF_STOCK }
];

interface OrderResetForm {
  orderId?: number;
  reason?: string;
}

const useOrderResetFormViewModel = (orderId: number) => {
  const {
    orderResetUpdateMutation: { mutateAsync }
  } = usePharmacyQuery();

  const [form, setForm] = useState<OrderResetForm>({
    orderId,
    reason: undefined
  });

  const isOutOfStockSelected = () => {
    return Boolean(form.reason === OptionType.OUT_OF_STOCK);
  };

  const changeReason = (reason: OptionType) => {
    setForm(form => ({
      ...form,
      reason:
        options.find(option => option.value === reason)?.value || undefined
    }));
  };

  const submit = async () => {
    if (!form.orderId || !form.reason) {
      throw new Error('입력 값을 확인해주세요.');
    }

    await mutateAsync({
      orderId: String(form.orderId),
      reason:
        options.find(option => option.value === form.reason)?.label ??
        '약국 사정으로 조제가 취소되었어요'
    });
  };

  return {
    submit,
    options,
    changeReason,
    isOutOfStockSelected
  };
};

export default useOrderResetFormViewModel;
